module.exports = __webpack_public_path__ + "static/media/lucina-win.706a9ea2.png";